<template>
  <div>
    <section class="hero">
      <img class="hero-logo" src="@/assets/dusty.gif" alt="Dusty, the Berkstresser LLC dust bunny mascot" />
      <h1>Berkstresser LLC Learning</h1>
      <p class="hero-tagline">Providing a quality, personalized education to those who are academically able but
        inadequately served by the public school system</p>
      <a class="cta-button" href="https://www.facebook.com/BerkstresserLLC" target="_blank"
        rel="noopener">Contact Us</a>
    </section>
    <div class="hello">
    <div class="homeCards">
      <Card class="homeCard">
        <template #header>
          <i class="pi pi-compass card-icon" aria-hidden="true"></i>
        </template>
        <template #title>Mission</template>
        <template #subtitle>Providing a quality, personalized education to those who are academically able but
          inadequately served by the public school system</template>
        <template #content>
          <p>
            Motivated students, no matter what age or subject, should have their chance at excellence. We can help.
          </p>

        </template>
      </Card>
      <Card class="homeCard">
        <template #header>
          <i class="pi pi-users card-icon" aria-hidden="true"></i>
        </template>
        <template #title>About Us</template>

        <template #content>
          <p>Berkstresser Learning is a home-based tutoring service with:</p>
          <ul>
            <li>A holistic approach to education</li>
            <li>A secular worldview</li>
            <li>A passion for teaching students who want to learn</li>
            <li>A passion for learning new things ourselves</li>
            <li>Over 35 years of combined education experience</li>
            <li>Grade levels & Subjects: K-12 in core subjects, English Language Learners, Lower college levels</li>
            <li>Flexible scheduling</li>
            <li>Virtual tutoring available when the subject and grade level allow</li>
            <li>Virtual tutoring via Zoom unless otherwise arranged</li>
          </ul>
        </template>

      </Card>
      <Card class="homeCard">
        <template #header>
          <i class="pi pi-phone card-icon" aria-hidden="true"></i>
        </template>
        <template #title>Contact Us</template>

        <template #content>
          <p>
            Visit us on <a target="_blank" rel="noopener" href="https://www.facebook.com/BerkstresserLLC">Facebook</a><br>
          </p>
          To reach tutors individually:
          <ul>
            <li>CJ Berkstresser (owner) - K-12 Math, ELA, Science, History
              <ul>
                <li>
                  <a href="tel:417-929-2533">417-929-2533</a>
                </li>
                <li>
                  <a href="mailto:cjberkstresser@gmail.com">cjberkstresser@gmail.com</a>
                </li>
              </ul>
            </li>
            <li>Kendell Loyd - HS Biology, College Biology, Can communicate through ASL
              <ul>
                <li>
                  <a href="tel:583-776-0901">583-776-0901</a>
                </li>
                <li>
                  <a href="mailto:kloyd892@gmail.com">kloyd892@gmail.com</a>
                </li>
              </ul>
            </li>
            <li>Caleb Berkstresser - HS-College Mathematics, Computer Science, English
              <ul>
                <li>
                  <a href="tel:417-929-2719">417-929-2719</a>
                </li>
                <li>
                  <a href="mailto:cdberkstresser@protonmail.com">cdberkstresser@protonmail.com</a>
                </li>
              </ul>
            </li>
          </ul>
          Located in Springfield & Willard, MO, but willing to Zoom anywhere!
        </template>

      </Card>
    </div>
    </div>
  </div>

</template>

<script lang="ts">
export default {
  name: "HomePage",
}
</script>

<script lang="ts" setup>
import Card from 'primevue/card';
import 'primeicons/primeicons.css';
</script>
